import styled from 'styled-components'

import MainLayout from '../../layouts/MainLayout'
import Breadcrumb from '../../components/Breadcrumb'
import ProductBanner from '../../components/ProductBanner'
import BannerOffer from '../../components/BannerOffer'
import DownloadFiles from '../../components/DownloadFiles'
import RetailerCard from '../../components/RetailerCard'
import membersFeedback from '../../components/MembersFeedback'
import { mq, sizes } from '../../theme'
import Icon from '../../components/Icon'

export const Layout = styled(MainLayout)`
  main {
    margin-top: 0;
    position: relative;
  }
`

export const GridWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3rem;

  @media ${mq(sizes.desktop)} {
    display: grid;
    gap: 3rem;
    grid-template-columns: 1fr 1fr;
  }
`

export const BreadcrumbElement = styled(Breadcrumb)`
  margin-top: 3.5rem;
`

export const BannerProduct = styled(ProductBanner)`
  .product-banner__block-content {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
`

export const OfferBanner = styled(BannerOffer)`
  @media ${mq(null, sizes.desktop)} {
    margin-left: -2rem;
    margin-right: -2rem;
  }
`

export const DescriptionDownloadBlock = styled.div`
  @media ${mq(sizes.desktop)} {
    grid-area: 1 / 1 / 2 / 3;
  }
`

export const OfferDescription = styled.div`
  ${({ theme }) => theme.textStyles.montserratTextBase};
  p {
    margin-bottom: 1rem;
  }
`

export const Download = styled(DownloadFiles)`
  @media ${mq(null, sizes.desktop)} {
    margin-left: -2rem;
    margin-right: -2rem;
  }
  margin-top: 3rem;
`

export const CardContainer = styled.div`
  @media ${mq(null, sizes.desktop)} {
    margin-left: -2rem;
    margin-right: -2rem;
  }

  @media ${mq(sizes.desktop)} {
    grid-area: 1 / 3 / 4 / 4;
    width: 365px;
  }
`

export const CardWrapper = styled.div`
  background-color: ${({ theme }) => theme.colors.brownBack};
  padding: 2.5rem 3.7rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 3rem;
  > div {
    max-width: 30rem;
  }
`

export const Brand = styled(RetailerCard)`
  background-color: ${({ theme }) => theme.colors.pureWhite};
`

export const Retailer = styled(RetailerCard)`
  background-color: ${({ theme }) => theme.colors.pureWhite};
`

export const Feedback = styled(membersFeedback)`
  margin-left: -2rem;
  margin-right: -2rem;

  @media ${mq(sizes.tablet)} {
    margin: 0;
  }

  @media ${mq(sizes.desktop)} {
    display: flex;
    flex-direction: column;
    max-width: 68rem;

    > div:last-child {
      margin-top: auto;
    }
  }

  @media ${mq(sizes.desktop)} {
    grid-area: 2 / 1 / 4 / 3;
  }
`

export const IconCrossesTop = styled(Icon)`
  position: absolute;
  top: -2.2rem;
  right: 1.8rem;

  @media ${mq(null, sizes.scopingMedium)} {
    display: none;
  }
`

export const IconCrossesBottom = styled(Icon)`
  position: absolute;
  top: 60%;
  left: 0;

  @media ${mq(null, sizes.scopingMedium)} {
    display: none;
  }
`
